import { signalStoreFeature, type, withMethods } from '@ngrx/signals';

export interface SubmittedFieldsState {
  [formKey: string]: {
    [fieldName: string]: boolean;
  };
}

export type LockableState = { submittedFields: SubmittedFieldsState };

export function withLockable() {
  return signalStoreFeature(
    { state: type<LockableState>() },
    withMethods(({ submittedFields }) => ({
      isFieldSubmitted(fieldName: string, formKey: string): boolean {
        return submittedFields()[formKey]?.[fieldName] ?? false;
      },
    })),
  );
}
